import React from "react";
import BreadCrumb from "Common/BreadCrumb";
import TableEstimateProject from "./TableEstimateProject";

const BasicTable = () => {
  return (
    <React.Fragment>
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        <BreadCrumb title="برآورد" pageTitle="Tables" />

        <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-1">
          <TableEstimateProject />
        </div>
      </div>
    </React.Fragment>
  );
};

export default BasicTable;
